import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function EditIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <title>Edit</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2883 5.54676L18.4544 9.71284L6.16569 22.0002H1.9996V17.8341L14.2883 5.54676ZM17.5096 2.32455C17.942 1.89206 18.6428 1.89206 19.0767 2.32455L21.6756 4.92485C22.1081 5.35734 22.1081 6.05814 21.6756 6.49064L19.6427 8.52362L15.4752 4.35754L17.5096 2.32455Z"
        />
      </g>
    </SvgIcon>
  );
}

export default EditIcon;
